import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import ListBuilder from '../../../components/listBuilder';
import ErrorModal from '../../../components/errorModal';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../../helpers/linkHelper';
import { API_ENDPOINT } from '../../../constants';
import { formValueSelector, change } from 'redux-form';  // ES6
import { connect } from 'react-redux';
import viewIcon from '../../../assets/svg/eye.svg';
import xIcon from '../../../assets/svg/x.svg';
import garbageIcon from '../../../assets/svg/garbage.svg';
import walletIcon from '../../../assets/svg/wallet.svg';
import warrning from '../../../assets/svg/warrning.svg';
import addIcon from '../../../assets/svg/add-icon-v2.svg'
import Payson from '../../../components/payson';
import Swish from '../../swish';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import PdfSave from '../../../components/pdvSave';
import InfoModal from '../../../components/infoModal';
import striptags from 'striptags';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import downloadIcon from '../../../assets/svg/download.svg';
import deleteDocument from '../../../assets/svg/delete-document.svg'
import saveIcon from '../../../assets/svg/save-icon.svg';


import billGrey from '../../../assets/svg/bill_grey.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import DatePicker from '../../../components/forms/fields/datePicker';
import Checkbox from '../../../components/forms/fields/checkbox';
import DeleteModal from '../../../components/deleteModal';
import PatientNotesPreview from '../../../components/patientNotesPreview';
import { fi, id, th } from 'react-date-range/dist/locale';
import CustomCalendarFilterSelect from '../../calendar/customCalendarFilterSelect';
import { getHumanReadableLabel, getHumanReadableStatus } from '../helper';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class CustomFiltersPatient extends Component {
    constructor(props) {
        super(props);


        this.state = {
            ...props.initialData,
            filters: {
                status: []
            }
        };
    }


    get = () => {
        this.setState({
            filters: {
                status: []
            }
        }, () => { this.setValue() });
    }


    componentDidMount() {

        this.get();


    }

    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState) {


    }



    setValue = () => {
        const filters = this.state.filters ?? {};

        if (this.props.onChange) {
            this.props.onChange(filters);
        }
    }

    render() {

        // const availableStatuses = this.props.availableStatuses ?? [];
        const availableStatuses = ['UNPAID', 'PAID', 'REFUNDED', 'payment_cancelled'];

        if (availableStatuses?.length < 2) return null;

        return (
            <div className='patient-payments-custom-filters-wrap'>

                {
                    availableStatuses?.map((item, idx) => {
                        const isChecked = this.state.filters?.status?.includes(item) ?? false;
                        const statusValue = getHumanReadableStatus(item !== 'payment_cancelled' ? item : 'Cancelled payments', this.props.lang);

                        return (
                            <div
                                key={idx}
                                className={isChecked ? 'custom-status-item custom-status-item-active' : 'custom-status-item'}
                                onClick={() => {
                                    let filters = this.state.filters ?? {};
                                    let status = filters?.status ?? [];
                                    if (status?.includes(item)) {
                                        status = status.filter(i => i !== item);
                                        if (item === 'REFUNDED') {
                                            status = status.filter(i => i !== 'PARTIALLY_REFUNDED');
                                        }
                                    } else {
                                        status.push(item);
                                        if (item === 'REFUNDED') {
                                            status.push('PARTIALLY_REFUNDED');
                                        }
                                    }
                                    filters.status = status;
                                    this.setState({ filters }, () => { this.setValue() });
                                }}
                            >
                                {statusValue}
                            </div>
                        )
                    })
                }

                {
                    this.state.error ?
                        <ErrorModal
                            lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}
                            closeButtonText={'Cancel'.translate(this.props.lang)}
                            zIndex={9999}
                        >
                            {this.state.error}
                        </ErrorModal>
                        :
                        null
                }
            </div >
        );
    }
}


export default CustomFiltersPatient;